import { FileX, ShieldAlert } from 'lucide-react';
import type { ReactNode } from 'react';
import { Navigate } from 'react-router';
import { DetailPageSkeleton } from '../../../../../shared/components/DetailPageSkeleton';
import { EmptyState } from '../../../../../shared/components/EmptyState';
import type { Crumb } from '../../../../../shared/components/section-trail';
import type { TyreDetailState } from '../hooks/use-tyre-detail';

/** What a tyre's page shows while it has no tyre to show: its skeleton, a redirect, or a message. Null once the tyre is loaded. */
export function tyreDetailFallback(state: TyreDetailState, breadcrumbs: Crumb[]): ReactNode {
  switch (state.status) {
    case 'forbidden':
      return <Navigate to="/" replace />;
    case 'loading':
      return <DetailPageSkeleton label="Loading tyre" breadcrumbs={breadcrumbs} tabs={1} />;
    case 'not_found':
      return <EmptyState icon={FileX} title="Tyre not found" description="This tyre doesn't exist, or the link is out of date." />;
    case 'error':
      return <EmptyState icon={ShieldAlert} title="Couldn't load this tyre" description="Something went wrong loading this tyre. Try reloading the page." />;
    default:
      return null;
  }
}
